import * as d3 from 'd3';

export const tau = Math.PI * 2;
export const trackWidth = 40;

export function getInnerRadius(tier, extra = 53) {
    return extra + (trackWidth * (tier));
}

export function getOuterRadius(tier, extra = 53) {
    return extra + (trackWidth * (tier + 1));
}

export function convertToAngles(beat, beatCount) {
    if (Math.abs(beat - beatCount) <= 0.0001) {
        return tau * 0.999999999;
    }
    return (beat / beatCount) * tau;
}


export function getAngleFromD3Event(svg, element, isFromDrag = false) {
    const pt = svg.createSVGPoint();
    pt.x = 0;
    pt.y = 0;
    const center = pt.matrixTransform(element.getScreenCTM());
    const event = isFromDrag ? d3.event.sourceEvent : d3.event;
    let clickX = event.clientX;
    let clickY = event.clientY;
    if (isNaN(clickX) && event.touches && event.touches.length > 0) {
        clickX = event.touches[0].clientX;
        clickY = event.touches[0].clientY;
    }
    const diffX = center.x - clickX;
    const diffY = center.y - clickY;

    return (((Math.PI * 2) + Math.atan2(diffY, diffX)) - (Math.PI / 2)) % (Math.PI * 2);
}

export function getBeatFromAngle(angle, beatCount, round = false, noround = false) {
    const beatAngleLength = tau / beatCount;
    const beat = angle / beatAngleLength;
    if (noround) {
        return beat;
    }
    return round ? Math.round(beat) : Math.floor(beat);
}

export function createD3Arc(innerRadius, outerRadius, startAngle, endAngle) {
    return d3.arc()
        .innerRadius(innerRadius)
        .outerRadius(outerRadius)
        .startAngle(startAngle)
        .endAngle(endAngle);
}
